import Vue from 'vue'
import Router from 'vue-router'
import nav from '@/views/nav'
import index from "@/views/film/index"
import detail from "@/views/film/detail"
import address from "@/views/film/address"
import result from "@/views/film/result"
import order_detail from "@/views/film/order_detail"
import login from "@/views/film/login"
import cart from "@/views/film/cart"
import order_pay from "@/views/film/order_pay"

import router from './router'
import store from './store';
import qs from 'qs'
import wechatAuth from './wechatAuth'
Vue.use(Router)

export default new Router({
  routes: [
  {
	  	path: '/',
      name: 'nav',
      component:nav,
      	children:[
			    {
			      path: '/',
			      name: 'index',
			      component:index,
//			      meta: {
//				        title: '提示',
//				        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
//				    },
				},
				{
					path: 'detail',
					name: 'detail',
					component:detail,
				},
				{
					path: 'address',
					name: 'address',
					component:address,
				},
			    {
					path: 'result',
					name: 'result',
					component:result,
				},
				{
					path: 'order_detail',
					name: 'order_detail',
					component:order_detail,
				},
				{
					path: 'cart',
					name: 'cart',
					component:cart,
				},
				{
					path: 'order_pay',
					name: 'order_pay',
					component:order_pay,
				},
	    	]
	 },
	 {
      path: '/login',
      name: 'login',
      component:login,
    },
    
  ]
  
});
